import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '..';
import {
	IDataMyPageStore,
	IPayloadGetMyPageListSuccess,
	IPayloadGetMyPageRequest,
	IPayloadUpdateDataMyPageRequest,
} from './my-page.type';

const initialState = {
	fetching: false,
	dataMyPage: {} as IDataMyPageStore,
};

const myPageSlice = createSlice({
	initialState,
	name: 'myPage',
	reducers: {
		/**---- GET MY_PAGE DATA START ---- */
		getDataMyPageRequest: (
			state,
			action: PayloadAction<IPayloadGetMyPageRequest | undefined>
		) => {
			state.fetching = true;
		},
		getDataMyPageSuccess: (
			state,
			action: PayloadAction<IPayloadGetMyPageListSuccess>
		) => {
			const { dataMyPage } = action.payload;
			state.fetching = false;
			state.dataMyPage = dataMyPage;
		},
		getDataMyPageFailure: (state) => {
			state.fetching = false;
			state.dataMyPage = {} as IDataMyPageStore;
		},
		/**---- GET MY_PAGE DATA END ---- */

		/**---- UPDATE MY_PAGE START ---- */
		updateDataMyPageRequest: (
			state,
			action: PayloadAction<IPayloadUpdateDataMyPageRequest>
		) => {
			state.fetching = true;
		},
		updateDataMyPageSuccess: (state) => {
			state.fetching = false;
		},
		updateDataMyPageFailure: (state) => {
			state.fetching = false;
		},
		/**---- UPDATE MY_PAGE END ---- */
		/**---- RESET MY_PAGE DATA START ---- */
		resetDataMyPage: (state) => {
			state.dataMyPage = {} as IDataMyPageStore;
		},
		/**---- RESET MY_PAGE DATA END ---- */
	},
});

export const MyPageSelectors = {
	selectDataMyPage: (state: RootState) => state.myPage.dataMyPage,
};

export const MyPageActions = myPageSlice.actions;
export const MyPageReducer = myPageSlice.reducer;
